import React from "react";
import { Heading } from "../Heading";
import { ITextCard } from "../../types/common";

import "./style.scss";

interface ITextCardProps {
  card: ITextCard;
  className?: string;
  step?: number;
}

const TextCard = ({
  card: {
    title, body, headingType = "h3", badgeText, betterV2,
  },
  className,
  step,
}: ITextCardProps) => (betterV2
  ? (
    <div className="text-card-betterV2">
      <div className="text-card-betterV2__step">
        {step}
      </div>
      <div className="text-card-betterV2__body">
        <div className="text-card-betterV2__body-header">
          <Heading type={headingType} className="text-card-betterV2__body-header__title">{title}</Heading>
          {badgeText && (
          <div className="text-card-betterV2__badge">
            <p>{badgeText}</p>
          </div>
          )}
        </div>
        <p className="text-card-betterV2__body-content">
          {body.body}
        </p>
      </div>
    </div>
  )
  : (
    <div className={className}>
      <Heading type={headingType}>{title}</Heading>
      <p>{body.body}</p>
    </div>
  ));

export default TextCard;
